import { render, staticRenderFns } from "./InfoModal.vue?vue&type=template&id=562543e8&scoped=true"
import script from "./InfoModal.vue?vue&type=script&lang=ts"
export * from "./InfoModal.vue?vue&type=script&lang=ts"
import style0 from "./InfoModal.vue?vue&type=style&index=0&id=562543e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562543e8",
  null
  
)

export default component.exports